"use client"
import { Component } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import * as XLSX from "xlsx"
import { URL_PATH } from "../../services/API"
import API from "../../services/API"
import redux from "../../common/Redux"
import Header from "../../components/Header"
import Modal from "../../components/Modal"
import Toast from "../../components/Toast"
import Button from "@mui/material/Button"
import ReportTable from "../../components/ReportTable"

const theme = {
  background: "#02111B",
  btnColor: "#FFC857",
  blackColor: "#07070A",
  dropdownColor: "#16232C",
  greytxtcolor: "#9CA3AF",
  greybordercolor: "#374151",
  primary: "#ffc857",
  secondary: "#bb0a21",
  white: "#ffffff",
  drawerBgColor: "#16232c",
  pageBgColor: "#041A29",
  redColor: "#ed1c24",
  greenColor: "#00a651",
  blueColor: "#00a8ff",
  mutedWhite: "#9CA3AF",
  rootBgColor: "#02111b",
}

class CustomerRatingsReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      version: 1,
      loading: false,
      modalVisible: false,
      modalData: null,
      orderData: null,
      startDate: null,
      endDate: null,
      selectedSearchFilter: "",
      searchContent: "",
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  componentDidMount() {
    this.getAllUsers()
  }

  getAllUsers = async () => {
    const { status, data } = await API(this, "get", URL_PATH.listAllUsers(this.props.selectedHotelId.id))
    console.log("Users data loaded", data)
  }

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  formatDateForAPI = (date) => {
    if (!date) return ""
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  getSearchOptions = () => [
    { value: "", label: "Select Search Filter" },
    // { value: "search_mobile", label: "Search by Mobile Number" },
    { value: "min_avg_rating", label: "Minimum Average Rating" },
  ]

  getApiUrl = (exportType = "") => {
    const { selectedHotelId } = this.props
    const { startDate, endDate, selectedSearchFilter, searchContent } = this.state

    const fromDate = this.formatDateForAPI(startDate)
    const toDate = this.formatDateForAPI(endDate)

    return URL_PATH.report(
      selectedHotelId.id,
      "customer_ratings",
      fromDate,
      toDate,
      exportType,
      selectedSearchFilter,
      searchContent,
    )
  }

  onView = (item) => {
    this.setState({
      modalVisible: true,
      modalData: item,
    })
  }

  exportReport = async (type) => {
    const { status, message } = await API(this, "get", this.getApiUrl(type))
    if (status === "success") {
      this.showToast(message, "success")
      this.setState({
        version: this.state.version + Math.random(),
      })
    } else {
      this.showToast(message, "error")
    }
  }

  applyDateFilter = () => {
    this.setState({
      version: this.state.version + Math.random(),
    })
  }

  handleSearchChange = (searchContent) => {
    this.setState({ searchContent }, () => {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.setState({
          version: this.state.version + Math.random(),
        })
      }, 500)
    })
  }

  handleSearchFilterChange = (selectedSearchFilter) => {
    this.setState({ selectedSearchFilter, searchContent: "" }, () => {
      if (!selectedSearchFilter) {
        this.setState({
          version: this.state.version + Math.random(),
        })
      }
    })
  }

  ExampleCustomInput = ({ value, onClick, placeholder }) => (
    <button
      onClick={onClick}
      style={{
        backgroundColor: theme.dropdownColor,
        color: theme.white,
        border: `1px solid ${theme.greybordercolor}`,
        borderRadius: "4px",
        padding: "10px 16px",
        cursor: "pointer",
        fontSize: "14px",
        minWidth: "140px",
        textAlign: "left",
      }}
    >
      {value || placeholder}
    </button>
  )

  exportCurrentUserOrders = () => {
    const { orderData, modalData } = this.state
    if (!orderData || !orderData.data || orderData.data.length === 0) {
      this.showToast("No order data to export", "warning")
      return
    }

    const customerInfo = [
      ["Customer Details", ""],
      ["Name", modalData.user_name],
      ["Email", modalData.user_email],
      ["Phone", modalData.user_phone],
      ["Total Orders", orderData.data.length],
      ["", ""],
      ["Order History", ""],
    ]

    const orderHeaders = [
      "Order ID",
      "Date",
      "Type",
      "Status",
      "Payment Method",
      "Total Amount (₹)",
      "Discount (₹)",
      "Tax (₹)",
      "Subtotal (₹)",
    ]

    const orderRows = orderData.data.map((order) => [
      order.id,
      moment(order.order_date_time).format("DD-MM-YYYY HH:mm"),
      order.order_type,
      order.order_status,
      order.payment_method || "N/A",
      Number.parseFloat(order.order_grand_total).toFixed(2),
      Number.parseFloat(order.discount || 0).toFixed(2),
      Number.parseFloat(order.tax || 0).toFixed(2),
      Number.parseFloat(order.subtotal || 0).toFixed(2),
    ])

    const totalAmount = orderData.data.reduce((sum, order) => sum + Number(order.order_grand_total), 0)
    const summaryRow = ["TOTAL", "", "", "", "", totalAmount.toFixed(2), "", "", ""]
    const exportData = [...customerInfo, orderHeaders, ...orderRows, summaryRow]

    const ws = XLSX.utils.aoa_to_sheet(exportData)
    const csv = XLSX.utils.sheet_to_csv(ws, { FS: ",", RS: "\n" })
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
    const fileName = `${modalData.user_name.replace(/\s+/g, "_")}_Orders_${moment().format("YYYYMMDD")}.csv`

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fileName)
    } else {
      const link = document.createElement("a")
      const url = URL.createObjectURL(blob)
      link.setAttribute("href", url)
      link.setAttribute("download", fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    this.showToast("Order history exported as CSV successfully", "success")
  }

  render() {
    const { modalData, modalVisible, orderData, toast, startDate, endDate } = this.state

    return (
      <div
        style={{
          backgroundColor: theme.rootBgColor,
          minHeight: "100vh",
          padding: "20px",
        }}
      >
        <Header title="Customers Rating" />

        <ReportTable
          key={this.state.version}
          export={true}
          api={this.getApiUrl()}
          title="Customer Ratings Analysis"
          searchPlaceholder="Search by customer name"
          onView={this.onView}
          exportFileName="CustomerRatings"
          dateFilter={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <DatePicker
                selected={startDate}
                onChange={(date) => this.setState({ startDate: date })}
                isClearable={false}
                closeOnScroll={true}
                placeholderText="From Date"
                customInput={<this.ExampleCustomInput />}
                dateFormat="yyyy-MM-dd"
              />
              <DatePicker
                selected={endDate}
                onChange={(date) => this.setState({ endDate: date })}
                isClearable={false}
                closeOnScroll={true}
                placeholderText="To Date"
                customInput={<this.ExampleCustomInput />}
                dateFormat="yyyy-MM-dd"
              />
              <Button
                variant="contained"
                onClick={this.applyDateFilter}
                sx={{
                  textTransform: "none",
                  backgroundColor: theme.btnColor,
                  color: theme.blackColor,
                  "&:hover": { backgroundColor: "#e6b34f" },
                  fontWeight: "500",
                  padding: "10px 20px",
                }}
              >
                Apply
              </Button>
              {(this.state.startDate || this.state.endDate) && (
                <Button
                  variant="outlined"
                  onClick={() =>
                    this.setState({
                      startDate: null,
                      endDate: null,
                      version: this.state.version + Math.random(),
                    })
                  }
                  sx={{
                    textTransform: "none",
                    borderColor: theme.greybordercolor,
                    color: theme.white,
                    "&:hover": { borderColor: theme.btnColor, backgroundColor: `${theme.btnColor}20` },
                    fontWeight: "500",
                    padding: "10px 20px",
                  }}
                >
                  Clear Dates
                </Button>
              )}
            </div>
          }
          advancedSearch={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <select
                value={this.state.selectedSearchFilter}
                onChange={(e) => this.handleSearchFilterChange(e.target.value)}
                style={{
                  backgroundColor: theme.dropdownColor,
                  color: theme.white,
                  border: `1px solid ${theme.greybordercolor}`,
                  borderRadius: "4px",
                  padding: "10px 16px",
                  fontSize: "14px",
                  minWidth: "200px",
                }}
              >
                {this.getSearchOptions().map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {this.state.selectedSearchFilter && (
                <input
                  type="text"
                  placeholder={
                    this.state.selectedSearchFilter === "search_mobile"
                      ? "Enter mobile number"
                      : this.state.selectedSearchFilter === "min_avg_rating"
                        ? "Enter minimum rating (1-5)"
                        : "Enter search value"
                  }
                  value={this.state.searchContent}
                  onChange={(e) => this.handleSearchChange(e.target.value)}
                  style={{
                    backgroundColor: theme.dropdownColor,
                    color: theme.white,
                    border: `1px solid ${theme.greybordercolor}`,
                    borderRadius: "4px",
                    padding: "10px 16px",
                    fontSize: "14px",
                    minWidth: "150px",
                  }}
                />
              )}
              {this.state.selectedSearchFilter && (
                <Button
                  variant="outlined"
                  onClick={() =>
                    this.setState({
                      selectedSearchFilter: "",
                      searchContent: "",
                      version: this.state.version + Math.random(),
                    })
                  }
                  sx={{
                    textTransform: "none",
                    borderColor: theme.greybordercolor,
                    color: theme.white,
                    "&:hover": { borderColor: theme.btnColor, backgroundColor: `${theme.btnColor}20` },
                    fontWeight: "500",
                    padding: "10px 20px",
                  }}
                >
                  Clear Search
                </Button>
              )}
            </div>
          }
          columns={[
            {
              title: "Name",
              key: "name",
            },
            {
              title: "Mobile No",
              key: "mobile",
            },
            {
              title: "Average Rating",
              key: "avg_rating",
              format: (val) => (val ? `${val}/5 ⭐` : "No Rating"),
            },
            {
              title: "Last Order",
              key: "last_order_date",
              format: (val) => (val ? moment(val).format("DD-MM-YYYY") : "N/A"),
            },
          ]}
        />

        {/* Customer Details Modal */}
        {modalVisible && modalData && (
          <Modal
            visible={modalVisible}
            onClose={() => {
              this.setState({
                modalVisible: false,
                modalData: null,
              })
            }}
            title={`Customer Details: ${modalData.user_name}`}
            width="80%"
          >
            <div
              style={{
                padding: "20px",
                backgroundColor: theme.background,
                color: theme.white,
                maxHeight: "70vh",
                overflowY: "auto",
              }}
            >
              {/* Customer Summary Cards */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "16px",
                  marginBottom: "24px",
                }}
              >
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Total Orders</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    {modalData.total_orders?.toLocaleString() || "0"}
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Average Rating</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    {modalData.avg_rating ? `${modalData.avg_rating}/5 ⭐` : "No Rating"}
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Customer Since</h4>
                  <p style={{ fontSize: "18px", fontWeight: "bold", margin: 0 }}>
                    {modalData.created_at ? moment(modalData.created_at).format("DD-MM-YYYY") : "N/A"}
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Last Order</h4>
                  <p style={{ fontSize: "18px", fontWeight: "bold", margin: 0 }}>
                    {modalData.last_order_date ? moment(modalData.last_order_date).format("DD-MM-YYYY") : "N/A"}
                  </p>
                </div>
              </div>

              {/* Customer Details */}
              <div
                style={{
                  backgroundColor: theme.pageBgColor,
                  padding: "20px",
                  borderRadius: "8px",
                  border: `1px solid ${theme.greybordercolor}`,
                }}
              >
                <h3 style={{ color: theme.btnColor, marginBottom: "16px" }}>Contact Information</h3>
                <div
                  style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "16px" }}
                >
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Name:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>{modalData.user_name || "N/A"}</p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Email:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>{modalData.user_email || "N/A"}</p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Phone:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>{modalData.user_phone || "N/A"}</p>
                  </div>
                  <div>
                    <strong style={{ color: theme.mutedWhite }}>Status:</strong>
                    <p style={{ margin: "4px 0", fontSize: "16px" }}>
                      <span
                        style={{
                          backgroundColor: theme.greenColor,
                          color: theme.white,
                          padding: "4px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        Active Customer
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        )}

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleToastClose}
        />
      </div>
    )
  }
}

export default redux(CustomerRatingsReport)
